import { ArrowRight } from "lucide-react";
import { offer, whatsappPrefill } from "@/config/site";
import { Section } from "./Section";
import { Reveal } from "./Reveal";

const PATHS = [
    { q: "Paint looks tired?", a: "Paint Correction" },
    { q: "Want to protect new paint?", a: "PPF" },
    { q: "Want gloss + easier maintenance?", a: "Ceramic" },
    { q: "Interior needs attention?", a: "Detailing" },
    { q: "Want to change the car?", a: "Custom" },
    { q: "Damage or bodywork?", a: "Bodyshop" },
];

export const CarNeeds = () => (
    <Section id="car-needs" index="04" label="Identify" title="What does your car actually need?" alt>
        <Reveal className="mt-6" delay={0.05}>
            <p className="max-w-[60ch] text-base leading-relaxed text-rz-smoke">
                Not every vehicle needs the same treatment. Start with what you're seeing — or let
                us inspect it and tell you.
            </p>
        </Reveal>
        <div className="mt-12 grid gap-px border border-rz-steel/60 bg-rz-steel/60 sm:grid-cols-2 lg:grid-cols-3">
            {PATHS.map((p, i) => (
                <Reveal
                    key={p.a}
                    delay={i * 0.05}
                    className="group bg-rz-carbon p-7 transition-colors duration-500 hover:bg-rz-graphite/60"
                >
                    <p className="text-sm text-rz-smoke">{p.q}</p>
                    <p className="mt-3 flex items-center gap-2 font-display text-lg font-bold uppercase tracking-wide text-rz-white">
                        <ArrowRight
                            size={16}
                            className="text-rz-red transition-transform duration-300 group-hover:translate-x-1"
                        />
                        {p.a}
                    </p>
                </Reveal>
            ))}
        </div>
        <Reveal
            className="mt-px flex flex-col items-start gap-5 border border-rz-steel/60 bg-rz-graphite/50 p-7 sm:flex-row sm:items-center sm:justify-between"
            delay={0.1}
        >
            <p className="font-display text-xl font-bold uppercase tracking-wide text-rz-white">
                Not sure? <span className="text-rz-red">Get a free inspection.</span>
            </p>
            <a
                data-testid="car-needs-inspection-cta"
                href={whatsappPrefill(offer.message)}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-sweep shrink-0 bg-rz-red px-7 py-3.5 font-display text-[12px] font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-rz-reddeep"
            >
                {offer.cta}
            </a>
        </Reveal>
    </Section>
);
